// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"57aca6e4","121":"eb9153d7","357":"e3080799","433":"3d396722","484":"32cbc892","537":"9eac8570","649":"f2ae1419","653":"ab7a33dc","743":"21cc53c3","868":"8adea759"}[chunkId] + ".chunk.js";
};